import { useRegionLanguageMap } from 'hooks/business/system/useRegionLanguage';
import { RefObject, useEffect, useRef } from 'react';
import { useAtom } from 'jotai';
import translateModeState from 'views/Aide/Scenario/PolicyForm/TranslateTool/translateModeState';

export function useNeuronTranslateMode(iframeRef: RefObject<HTMLIFrameElement>, neuronId: string) {
  const [translateMode, setTranslateMode] = useAtom(translateModeState);

  const regionLanguageMap = useRegionLanguageMap();

  const refsCurrent = {
    translateMode,
    setTranslateMode,
    regionLanguageMap,
  };
  const refs = useRef(refsCurrent);
  refs.current = refsCurrent;

  useEffect(() => {
    const handler = (e: MessageEvent) => {
      if (!e.data || e.data.neuronId !== neuronId) {
        return;
      }

      if (!iframeRef.current || !iframeRef.current.contentWindow) {
        return;
      }

      const {
        current: { contentWindow: neuron },
      } = iframeRef;

      const {
        current: { translateMode, setTranslateMode, regionLanguageMap },
      } = refs;

      if (e.data.type === 'requestTranslateMode') {
        neuron.postMessage(
          {
            type: 'translateModeChange',
            translateMode,
            regionLanguageMap,
            neuronId,
          },
          '*',
        );
      }

      if (e.data.type === 'changeTranslateMode') {
        setTranslateMode(e.data.translateMode);
      }
    };

    window.addEventListener('message', handler);

    return () => window.removeEventListener('message', handler);
  }, [iframeRef, neuronId]);

  useEffect(() => {
    if (!iframeRef || !iframeRef.current) return;

    const {
      current: { contentWindow: neuron },
    } = iframeRef;

    neuron?.postMessage(
      {
        type: 'translateModeChange',
        translateMode,
        regionLanguageMap,
        neuronId,
      },
      '*',
    );
  }, [translateMode, regionLanguageMap, iframeRef, neuronId]);
}

export default useNeuronTranslateMode;
